/**
 * Русский набор строк. Запасной: неподдерживаемый язык браузера даёт его.
 */

import type { Strings } from './index';

export const ru: Strings = {
  login_title: 'Вход в CargoPASS',
  login_phone_label: 'Номер телефона',
  login_code_request: 'Получить код',
  login_code_label: 'Код из сообщения',
  login_code_submit: 'Войти',
  login_failed: 'Войти не удалось. Попробуйте ещё раз.',
  works_title: 'Работы',
  works_more: 'Показать ещё',
  works_failed: 'Список загрузить не удалось.',

  // Ключи блока `WEB-1.1`: оболочка кабинета, четыре состояния экрана, вторая
  // ветка входа и согласие с условиями. Юридического текста условий здесь нет
  // ни в одном виде — его пишет человек, а временная строка была бы заглушкой.
  login_channel_phone: 'По телефону',
  login_channel_email: 'По электронной почте',
  login_email_label: 'Адрес электронной почты',
  login_terms_label: 'Принимаю условия использования',
  company_switcher_label: 'Фирма',
  language_label: 'Язык',
  state_loading: 'Загрузка…',
  state_empty: 'Пока ничего нет',
  state_error: 'Данные получить не удалось',
  state_no_access: 'Эта страница вам недоступна',
  no_membership_title: 'Вы не состоите ни в одной фирме',
  no_membership_explain: 'Чтобы начать работу, вступите в фирму или заведите свою.',
  company_create_submit: 'Создать фирму',
  company_name_label: 'Название фирмы',
  company_form_type_label: 'Тип фирмы',
  company_tax_id_label: 'Регистрационный номер',
  company_legal_address_label: 'Юридический адрес',
  company_members_title: 'Состав фирмы',
  not_found_title: 'Такой страницы нет',

  // Ключи блока `WEB-1.2`: профиль пользователя, сотрудники, права, профиль
  // фирмы и документы. Подписи значений перечней собираются строителями ключа
  // из значения, пришедшего с сервера, и потому на экране литералом не стоят.
  profile_title: 'Мой профиль',
  profile_sessions_title: 'Активные сессии',
  profile_session_current: 'Текущая сессия',
  profile_session_never_used: 'Ни разу не использовалась',
  profile_session_terminate: 'Завершить',
  profile_channel_add: 'Добавить канал связи',
  profile_channel_code_request: 'Выслать код',
  profile_channel_confirm: 'Подтвердить канал',
  members_title: 'Сотрудники',
  members_invite: 'Пригласить сотрудника',
  invite_channel_phone: 'Телефоном',
  invite_channel_email: 'Почтой',
  invite_role_label: 'Роль',
  invite_submit: 'Отправить приглашение',
  invitations_title: 'Приглашения',
  invitation_revoke: 'Отозвать',
  invitation_resend: 'Отправить снова',
  rights_title: 'Права сотрудника',
  rights_grants: 'Выданные сверх роли',
  rights_denies: 'Запрещённые лично',
  rights_grant_add: 'Выдать право',
  rights_deny_add: 'Поставить запрет',
  rights_remove: 'Убрать',
  company_profile_title: 'Профиль фирмы',
  company_documents_title: 'Документы фирмы',
  company_type_transport: 'Перевозчик',
  company_type_logistics: 'Логистическая фирма',
  member_documents_title: 'Документы сотрудника',
  document_download: 'Открыть файл',
  enum_unknown: 'Неизвестно',
  role_director: 'Директор',
  role_logist: 'Логист',
  role_dispatcher: 'Диспетчер',
  role_accountant: 'Бухгалтер',
  role_mechanic: 'Механик',
  role_driver: 'Водитель',
  member_status_active: 'Действует',
  member_status_closed: 'Закрыто',
  permission_company_staff_manage: 'Управление сотрудниками',
  permission_company_rights_manage: 'Управление правами',
  permission_company_fleet_manage: 'Управление автопарком',
  permission_company_fleet_repair: 'Отметка о ремонте',
  permission_company_docs_manage: 'Управление документами',
  permission_company_listings_manage: 'Управление объявлениями',
  permission_company_cargo_take: 'Брать грузы',
  // РОСТ 0.9.30 (BE-2.4, шаг CONTRACT; решение D525): восьмое право каталога — привязка транспорта и водителя.
  permission_company_works_assign: 'Назначать транспорт и водителя',
  permission_company_accounting_manage: 'Вести расходы и выплаты фирмы',
  document_status_pending: 'На проверке',
  document_status_verified: 'Подтверждён',
  document_status_rejected: 'Отклонён',
  document_status_expired: 'Срок истёк',
  document_status_not_verified: 'Не подтверждён',
  invitation_status_pending: 'Ожидает ответа',
  invitation_status_accepted: 'Принято',
  invitation_status_revoked: 'Отозвано',
  invitation_status_expired: 'Срок вышел',

  // Ключи блока `WEB-1.3`: транспорт фирмы, цикл ремонта, сервисная история и
  // заявки на освобождение VIN. Подписи значений перечней собираются
  // строителями ключа из значения, пришедшего с сервера.
  fleet_title: 'Транспорт фирмы',
  fleet_add: 'Добавить транспорт',
  fleet_vin: 'VIN',
  fleet_tech_passport: 'Номер техпаспорта',
  fleet_kind_label: 'Вид транспорта',
  fleet_body_type_label: 'Тип кузова',
  fleet_withdraw: 'Вывести из реестра',
  fleet_withdrawn_at: 'Дата вывода',
  fleet_empty: 'В реестре пока пусто',
  service_title: 'Сервис машины',
  service_state_label: 'Техническое состояние',
  service_state_change: 'Перевести состояние',
  service_records_title: 'Журнал работ',
  service_record_add: 'Внести запись',
  service_description: 'Что сделано, какие узлы',
  service_parts: 'Запчасти',
  service_cost: 'Расход',
  service_currency: 'Валюта',
  service_records_empty: 'Записей пока нет',
  vin_claims_title: 'Заявки на освобождение VIN',
  vin_claim_create: 'Подать заявку',
  vin_claim_object: 'Возразить',
  vin_claim_window_ends_at: 'Окно возражения до',
  vin_claims_empty: 'Заявок пока нет',
  vehicle_kind_tractor: 'Тягач',
  vehicle_kind_trailer: 'Прицеп',
  body_type_tarpaulin: 'Тент',
  body_type_refrigerator: 'Рефрижератор',
  body_type_isothermal: 'Изотермический',
  body_type_box: 'Фургон',
  body_type_flatbed: 'Бортовой',
  body_type_platform: 'Платформа',
  body_type_lowbed: 'Трал',
  body_type_mega: 'Мега',
  body_type_car_carrier: 'Автовоз',
  body_type_tipper: 'Самосвал',
  body_type_walking_floor: 'Подвижный пол',
  body_type_tank: 'Цистерна',
  body_type_silo: 'Силос',
  body_type_container_chassis: 'Контейнеровоз',
  body_type_bdf: 'Кузов BDF',
  body_type_timber: 'Лесовоз',
  body_type_livestock: 'Скотовоз',
  body_type_coil: 'Койловоз',
  body_type_heavy_haul: 'Негабарит',
  body_type_extendable: 'Раздвижной',
  repair_state_fault_detected: 'Неисправность выявлена',
  repair_state_in_repair: 'В ремонте',
  repair_state_repaired: 'Отремонтировано',
  repair_state_ready: 'Готов',
  vehicle_status_active: 'В реестре',
  vehicle_status_withdrawn: 'Выведен',
  vin_claim_status_pending: 'Окно возражения открыто',
  vin_claim_status_objected: 'Возражение подано',
  vin_claim_status_awaiting_admin: 'Ждёт решения персонала',
  vin_claim_direction_outgoing: 'Наша заявка',
  vin_claim_direction_incoming: 'Заявка к нам',

  // Ключи блока `WEB-3.2` — страница публичного отслеживания по ссылке с PIN
  // (словарь §11 спецификации блока) и подписи двух перечней контракта.
  tracking_title: 'Отслеживание перегона',
  tracking_pin_hint: 'Введите PIN из шести цифр — его дал заказчик вместе со ссылкой. Без PIN страница ничего не покажет.',
  tracking_pin_label: 'PIN из шести цифр',
  tracking_pin_submit: 'Открыть',
  tracking_offline: 'Нет связи. Проверьте интернет и попробуйте ещё раз.',
  tracking_offline_refresh: 'Нет связи — обновлю, когда связь вернётся.',
  tracking_status_changed_at: 'Статус сменился',
  tracking_vehicle: 'Машина',
  tracking_route: 'Маршрут',
  tracking_distance: 'Расстояние',
  tracking_transit: 'Транзит',
  tracking_border_crossings: 'Пересечений границ',
  tracking_last_position: 'Последняя точка',
  tracking_no_position: 'Положение ещё не получено',
  tracking_open_map: 'Открыть в картах',
  tracking_photos: 'Приёмка машины',
  tracking_photo_open: 'Открыть фото',
  tracking_photo_plate: 'Госномер',
  tracking_photo_close: 'Закрыть',
  tracking_milestones: 'Этапы',
  tracking_locked_title: 'Ссылка временно недоступна',
  tracking_retry: 'Ввести PIN снова',
  tracking_gone_title: 'Ссылка не действует',
  tracking_map_title: 'Карта: последняя точка',
  work_status_CREATED: 'Создана',
  work_status_ASSIGNED: 'Назначена',
  work_status_ACCEPTED: 'Принята к исполнению',
  work_status_AT_PICKUP: 'На погрузке',
  work_status_AT_HANDOVER: 'Приёмка машины',
  work_status_IN_TRANSIT: 'В пути',
  work_status_DELIVERED: 'Сдано',
  work_status_COMPLETED: 'Завершено',
  work_status_CANCELLED: 'Отменено',
  work_status_ARCHIVED: 'В архиве',
  peregon_vehicle_kind_tractor: 'Тягач',
  peregon_vehicle_kind_tractor_with_trailer: 'Тягач с прицепом',
  peregon_vehicle_kind_car: 'Легковой автомобиль',

  // Ключи блока `WEB-2.1` — кабинет логиста: «Мои объявления», форма
  // объявления, карточка с offer'ами и доской заказа (словарь §11
  // спецификации блока) и подписи девяти перечней контракта.
  cargo_listings_title: 'Объявления о грузе',
  cargo_listings_create: 'Создать объявление',
  cargo_listings_more: 'Показать ещё',
  cargo_listings_empty: 'Объявлений пока нет',
  cargo_listing_edit: 'Изменить',
  cargo_listing_close: 'Закрыть',
  cargo_listing_close_confirm: 'Закрыть объявление? Закрытое объявление в ленту не вернётся.',
  cargo_listing_km: 'км',
  cargo_listing_kg: 'кг',
  cargo_listing_days: 'дн.',
  cargo_listing_transit: 'Транзит',
  cargo_listing_borders: 'Пересечений границ',
  cargo_listing_slots_free: 'Свободно',
  cargo_listing_slots_of: 'из',
  cargo_listing_fixed: 'Цена фиксирована',
  cargo_listing_payment: 'Оплата',
  cargo_listing_form_title_new: 'Новое объявление о грузе',
  cargo_listing_form_title_edit: 'Изменение объявления о грузе',
  cargo_listing_form_origin: 'Город погрузки',
  cargo_listing_form_destination: 'Город выгрузки',
  cargo_listing_form_city_search: 'Начните вводить название города',
  cargo_listing_form_loading_at: 'Дата погрузки',
  cargo_listing_form_unload_by: 'Выгрузить до',
  cargo_listing_form_vehicles_count: 'Сколько нужно машин',
  cargo_listing_form_cargo_type: 'Груз',
  cargo_listing_form_weight: 'Вес на одну машину, кг',
  cargo_listing_form_adr: 'Опасный груз (ADR)',
  cargo_listing_form_body_type: 'Тип кузова',
  cargo_listing_form_body_subtype: 'Подтип кузова',
  cargo_listing_form_temperature_from: 'от',
  cargo_listing_form_temperature_to: 'до',
  cargo_listing_form_price: 'Цена за одну машину',
  cargo_listing_form_currency: 'Валюта',
  cargo_listing_form_negotiable: 'Торг разрешён',
  cargo_listing_form_payment_method: 'Способ оплаты',
  cargo_listing_form_payment_moment: 'Когда оплата',
  cargo_listing_form_deferral_days: 'Дней отсрочки',
  cargo_listing_form_comment: 'Комментарий',
  cargo_listing_form_submit: 'Опубликовать',
  cargo_listing_form_save: 'Сохранить изменения',
  cargo_offers_title: 'Предложения перевозчиков',
  cargo_offer_accept: 'Одобрить',
  cargo_offer_decline: 'Отклонить',
  cargo_offer_decline_confirm: 'Отклонить предложение? Перевозчик увидит отказ.',
  cargo_offer_agrees: 'Согласен на ваши условия',
  cargo_offer_counter: 'Предлагает свою цену',
  cargo_offer_documents_verified: 'Документы проверены',
  cargo_offer_vehicles: 'Машин',
  cargo_offer_price: 'Цена перевозчика',
  cargo_offer_listing_price: 'Цена объявления',
  cargo_offer_expires: 'Ответить до',
  cargo_offer_more: 'Ещё предложения',
  cargo_slots_title: 'Доска заказа',
  cargo_slot_work: 'Работа',
  listing_status_OPEN: 'Открыто',
  listing_status_TAKEN: 'Все машины найдены',
  listing_status_CLOSED: 'Закрыто',
  listing_status_CANCELLED: 'Отменено',
  listing_status_PENDING_REVIEW: 'На проверке',
  listing_status_REJECTED: 'Отклонено',
  cargo_offer_status_PENDING: 'Ждёт решения',
  cargo_offer_status_APPROVED: 'Одобрено — ждёт подтверждения перевозчика',
  cargo_offer_status_CONFIRMED: 'Подтверждено перевозчиком',
  cargo_offer_status_REJECTED: 'Отклонено',
  cargo_offer_status_WITHDRAWN: 'Отозвано перевозчиком',
  cargo_offer_status_EXPIRED: 'Срок истёк',
  cargo_offer_status_SUPERSEDED: 'Свободных машин не осталось',
  cargo_slot_status_OPEN: 'Свободен',
  cargo_slot_status_RESERVED: 'Ждёт подтверждения перевозчика',
  cargo_slot_status_TAKEN: 'Занят',
  cargo_slot_status_CANCELLED: 'Отменён',
  currency_USD: 'USD ($)',
  currency_UZS: 'UZS (сум)',
  currency_EUR: 'EUR (€)',
  payment_method_cash: 'Наличными',
  payment_method_bank_transfer: 'Перечислением на счёт',
  payment_moment_prepayment: 'Предоплата',
  payment_moment_on_unloading: 'При выгрузке',
  payment_moment_deferred: 'С отсрочкой',
  loading_type_rear: 'Задняя',
  loading_type_side: 'Боковая',
  loading_type_top: 'Верхняя',
  loading_type_full_uncover: 'С полной растентовкой',
  body_parameter_length_m: 'Длина, м',
  body_parameter_width_m: 'Ширина, м',
  body_parameter_height_m: 'Высота, м',
  body_parameter_volume_m3: 'Объём, м³',
  body_parameter_capacity_t: 'Грузоподъёмность, т',
  body_parameter_loading_type: 'Тип загрузки',
  body_parameter_temperature: 'Температура, °C',
  body_parameter_cars_capacity: 'Вместимость, автомобилей',

  // Ключи блока `WEB-2.4`: карточка машины, водители фирмы, строки запчастей,
  // файл техпаспорта заявки, дата рождения и пол; подписи пола и типа документа.
  vehicle_card_title: 'Карточка машины',
  vehicle_photo_title: 'Фото машины',
  vehicle_photo_file: 'Выберите фото',
  vehicle_photo_add: 'Добавить фото',
  vehicle_photo_delete: 'Удалить',
  vehicle_photo_delete_confirm: 'Удалить это фото машины?',
  vehicle_photo_empty: 'Фото пока нет',
  vehicle_fault_title: 'Открытые неисправности',
  vehicle_fault_empty: 'Открытых неисправностей нет',
  vehicle_fault_author_unknown: 'Автор не указан',
  vehicle_fault_comment: 'Что не так с машиной',
  vehicle_fault_photos: 'Фото неисправности',
  vehicle_fault_add: 'Записать неисправность',
  vehicle_fault_history: 'Все неисправности',
  vehicle_fault_open: 'Открыта',
  vehicle_fault_closed: 'Закрыта',
  vehicle_fault_history_empty: 'Неисправностей у машины не было',
  drivers_title: 'Водители фирмы',
  drivers_age: 'Возраст:',
  drivers_name_unknown: 'Имя не указано',
  drivers_not_specified: 'не указан',
  drivers_self_reported: 'Имя, возраст и пол указаны самим человеком',
  drivers_documents: 'Документы',
  drivers_empty: 'Водителей пока нет',
  service_part_add: 'Добавить строку',
  service_part_remove: 'Убрать',
  service_part_name: 'Название запчасти',
  service_part_quantity: 'Количество',
  vin_claim_file_label: 'Файл техпаспорта — фото или PDF',
  vin_claim_file_link: 'Техпаспорт',
  vin_claim_file_missing: 'Подана без файла',
  profile_birth_date: 'Дата рождения',
  profile_gender: 'Пол',
  profile_gender_unspecified: 'Не указан',
  profile_personal_note: 'Указано самим человеком',
  profile_personal_hint: 'Видно вам; членам фирмы — только возраст и пол',
  profile_personal_save: 'Сохранить',
  gender_male: 'Мужской',
  gender_female: 'Женский',
  document_type_passport: 'Паспорт',
  document_type_driver_license: 'Водительское удостоверение',
  document_type_adr_certificate: 'Свидетельство ДОПОГ (ADR)',
  document_type_professional_certificate: 'Профессиональное свидетельство',
  document_type_face_snapshot: 'Снимок лица',
  document_type_tachograph_card: 'Карта тахографа',
  document_type_code95_card: 'Карта «Код 95»',
  document_type_visa: 'Виза',
  document_type_registration_certificate: 'Свидетельство о регистрации',
  expenses_title: 'Расходы',
  expenses_create: 'Записать расход',
  expenses_delete_confirm: 'Удалить этот расход?',
  expenses_empty: 'Расходов пока нет',
  expense_form_submit: 'Сохранить расход',
  expense_form_category: 'Категория',
  expense_form_spent_on: 'Дата расхода',
  expense_form_vehicle: 'Машина',
  expense_form_receipt: 'Чек — фото или PDF',
  expense_receipt_refreshed: 'Ссылка на чек обновлена — откройте ещё раз',
  expense_receipt_replace_hint: 'новый файл заменит прежний',
  payouts_title: 'Выплаты',
  payouts_create: 'Записать выплату',
  payouts_delete_confirm: 'Удалить эту выплату?',
  payouts_empty: 'Выплат пока нет',
  payout_form_submit: 'Сохранить выплату',
  payout_form_recipient: 'Получатель',
  payout_form_paid_on: 'Дата выплаты',
  payout_recipient_unnamed: 'Имя не указано',
  payout_recipient_not_listed: 'Не в списке водителей фирмы',
  payout_recipient_unavailable: 'Имя получателя недоступно',
  payout_recipient_loading: 'Получатель загружается…',
  accounting_edit: 'Изменить',
  accounting_delete: 'Удалить',
  accounting_more: 'Показать ещё',
  accounting_works_more: 'Показать ещё работы',
  accounting_filter_reset: 'Сбросить',
  accounting_filter_empty: 'По этому отбору записей нет',
  accounting_filter_any: 'Все',
  accounting_work_fallback: 'Работа',
  accounting_vehicle_fallback: 'Машина',
  accounting_vehicle_missing: 'Машина не найдена в реестре',
  accounting_no_vehicle: 'Без машины',
  accounting_no_work: 'Без работы',
  accounting_field_amount: 'Сумма',
  accounting_field_currency: 'Валюта',
  accounting_field_work: 'Работа',
  accounting_field_comment: 'Комментарий',
  accounting_choose: 'Выберите',
  accounting_form_close: 'Отмена',
  expense_category_diesel: 'Дизельное топливо',
  expense_category_parking: 'Стоянка',
  expense_category_toll: 'Платная дорога',
  expense_category_service: 'Сервис и ремонт',
  expense_category_other: 'Прочее',
  // Ключи блока `WEB-2.2`: кабинет диспетчера — лента грузов, offer, работы
  // фирмы, назначение транспорта и водителя, причины недоступности машины.
  cargo_feed_title: 'Лента грузов',
  cargo_feed_apply: 'Применить',
  cargo_feed_reset: 'Сбросить',
  cargo_feed_more: 'Показать ещё',
  cargo_feed_details: 'Подробнее',
  cargo_feed_company_verified: 'Фирма проверена',
  cargo_feed_adr: 'Опасный груз (ADR)',
  cargo_feed_empty: 'Подходящих объявлений нет',
  cargo_feed_loading_from: 'Погрузка с',
  cargo_feed_loading_to: 'Погрузка по',
  cargo_feed_vehicles_min: 'Машин от',
  cargo_feed_weight_from: 'Вес от, кг',
  cargo_feed_weight_to: 'Вес до, кг',
  cargo_feed_body_type: 'Тип кузова',
  cargo_feed_temperature: 'Температурный режим',
  cargo_feed_price_from: 'Цена за машину от',
  cargo_feed_price_to: 'Цена за машину до',
  cargo_feed_currency: 'Валюта цены',
  cargo_feed_q: 'Ключевое слово',
  cargo_feed_any: 'Не важно',
  cargo_feed_yes: 'Да',
  cargo_feed_no: 'Нет',
  cargo_feed_cities_title: 'Города отправления',
  cargo_feed_cities_total: 'Всего объявлений',
  cargo_feed_date_hint: 'ГГГГ-ММ-ДД',
  cargo_feed_my_offer: 'Предложение вашей фирмы',
  cargo_feed_listing_no_right: 'Подавать предложения может сотрудник с правом брать грузы — его выдаёт директор',
  cargo_feed_listing_unavailable: 'От этой фирмы подать предложение на это объявление сейчас нельзя',
  cargo_feed_listing_agree: 'Согласен на ваши условия',
  cargo_feed_listing_own_price: 'Своя цена',
  cargo_feed_listing_fixed_price: 'Цена фиксирована',
  cargo_feed_listing_negotiable: 'Торг возможен',
  cargo_feed_listing_submit: 'Отправить предложение',
  cargo_feed_listing_price_amount: 'Ваша цена за машину',
  cargo_offers_mine_title: 'Мои предложения',
  cargo_offers_confirm: 'Подтвердить',
  cargo_offers_withdraw: 'Отозвать',
  cargo_offers_withdraw_confirm: 'Отозвать предложение? Логист больше не будет его рассматривать.',
  cargo_offers_more: 'Показать ещё предложения',
  cargo_offers_agrees: 'Согласие на условия',
  cargo_offers_counter: 'Своя цена',
  cargo_offers_vehicles: 'Машин',
  cargo_offers_empty: 'Предложений пока нет',
  cargo_offers_price: 'Цена за машину',
  cargo_offers_expires: 'Ответ логиста до',
  cargo_offers_confirm_by: 'Подтвердить до',
  cargo_offers_sender: 'Подал',
  works_to_assign_title: 'Ждут назначения',
  works_to_assign_empty: 'Работ, ждущих назначения, нет',
  works_empty: 'Работ пока нет',
  works_assign: 'Назначить',
  works_replace: 'Заменить',
  work_assignment_title: 'Назначение транспорта и водителя',
  work_assignment_tractor: 'Тягач',
  work_assignment_trailer: 'Прицеп',
  work_assignment_driver: 'Водитель',
  work_assignment_no_trailer: 'Без прицепа',
  work_assignment_unnamed: 'Имя не указано',
  work_assignment_assign: 'Назначить',
  work_assignment_replace: 'Заменить',
  work_assignment_current: 'Сейчас назначены',
  work_assignment_assigned_at: 'Назначены',
  work_assignment_history: 'История привязок',
  work_assignment_history_empty: 'Замен не было',
  work_assignment_assigned_by: 'Назначил',
  work_assignment_replaced_by: 'Снял',
  work_assignment_unavailable: 'Назначение и замена для этой работы сейчас недоступны',
  unassignable_reason_withdrawn: 'Выведена из реестра',
  unassignable_reason_not_ready: 'Не готова к рейсу',
  unassignable_reason_busy: 'Занята другой работой',
};
